import { render } from "./AW23Hero.vue?vue&type=template&id=529a0c5a&scoped=true"
import script from "./AW23Hero.vue?vue&type=script&lang=js"
export * from "./AW23Hero.vue?vue&type=script&lang=js"

import "./AW23Hero.vue?vue&type=style&index=0&id=529a0c5a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529a0c5a"]])

export default __exports__